import request, { Res } from '@/utils/request'
import md5 from 'md5'
import qs from 'qs'

// 获取老师课程
export const getTeacherLessons = (data: any) => {
  return request.post<Res, Res>(`/pc_api/api/pc/v1/teacherLessons`, qs.stringify(data))
}

// 日历接口
export const classTable = () => {
  return request.post<Res, Res>(`/pc_api/api/pc/classTable`)
}

// 获取已上课程
export const getTeacherLessonList = (data: any) => {
  return request.post<Res, Res>(`/pc_api/api/pc/teacherLessonList`, qs.stringify(data))
}

// 课件详情
export const getCourseInfo = (data: any) => {
  return request.post<Res, Res>(`/pc_api/api/pc/courseDetail`, qs.stringify(data))
}

// 获取点评
export const getComment = (data: any) => {
  return request.post<Res, Res>(`/pc_api/api/pc/app/lessoninfo`, qs.stringify(data))
}

// 获取设备信息
export const getDeviceInfo = (data: any) => {
  const timestamp = (Date.now() / 1000).toFixed(0)
  const signParams = `userId=${data.userId}&userType=${data.userType}&timestamp=${timestamp}&key=${import.meta.env.VITE_APP_SECRETKEY}`
  const sign = md5(signParams)
  return request.post<Res, Res>(
    `/pc_api/api/pc/device/deviceInfo`,
    qs.stringify({
      ...data,
      sign,
      timestamp
    })
  )
}

// 进教室
export const inRoom = (data: any) => {
  return request.post<Res, Res>(`/pc_api/api/pc/inRoom`, qs.stringify(data))
}

// 服务器时间
export const getServerTimes = () => {
  return request.get<number | string, number | string>(`/pc_api/api/pc/getTimeStamp`)
}

// 家长期望
export const parentHope = (data: any) => {
  return request.post<Res, Res>(`/pc_api/api/pc/teacher/parentHope`, qs.stringify(data))
}
